import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "8", y2: "16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "16", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PlusSquare";
const PlusSquare = memo(themed(Icon));
export {
  PlusSquare
};
//# sourceMappingURL=plus-square.js.map
